import templateUrl from '../views/modals/bulk-message-modal.tpl.html';
import VoucherBulkMessageModalController from "../controllers/modals/bulk-send/voucher-bulk-message-modal";

export default function voucherBulkMessageModalCreator($injector, recipientsStore, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};
    return $injector.get('$uibModal').open({
        controller: VoucherBulkMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientsStore
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/voucher-bulk-message-modal-creator.js